@if (loading$ | async) {
  <app-loading [size]="'3x'"></app-loading>
}

@if (!(loading$ | async) && !pickerMode) {
  <div class="algorithms">
    @let attached = (attachedAlgorithms$ | async) ?? [];
    @let pending = (pendingAlgorithmIds$ | async) ?? [];

    @if (attached.length === 0) {
      <div class="no-algorithms">
        {{ "feed-algorithms.message.no-attached" | translate }}
      </div>
    }

    @for (algorithm of attached; track algorithm.id) {
      <app-algorithm-list-card
        [algorithm]="algorithm"
        [pending]="isAlgorithmPending(algorithm.id, pending)"
        [editable]="hasEditableParams(algorithm)"
        (detach)="detachAlgorithm($event)"
        (edit)="editAlgorithm($event)"
      ></app-algorithm-list-card>
    }
  </div>
}

@if (!(loading$ | async) && pickerMode) {
  <div class="picker-container">
    <div class="picker-hint">
      {{ "feed-algorithms.message.pick-to-attach" | translate }}
    </div>

    <app-algorithm-picker
      [algorithms]="(availableAlgorithms$ | async) ?? []"
      (selectionChange)="onPickerSelectionChange($event)"
    ></app-algorithm-picker>
  </div>
}
